export default __webpack_public_path__ + "1c97136508739f5d2fa2e3171c2456c9.png";